// Where the receipt OCR service's address is read, and nothing else.
//
// The service is deployed separately, so the app must work without it: when
// VITE_RECEIPT_OCR_URL is unset the receipt option is not offered at all,
// rather than offered and failing.
//
// ── Unloadable by jest, on purpose (#112) ───────────────────────────────────
//
// `import.meta.env` is a Vite build-time substitution. Babel emits it
// verbatim, so under jest this is a parse error: the file fails whole, and so
// does anything that imports it, even with the read inside a function (#106).
// So only the environment reads and their wiring live here; the request is
// ./receiptOcrClient.js and the limits are ./fileLimits.js (#96, #113).
//
// Build-time configuration is read here and named only by a page:
// `src/pages/ExpensesPage.jsx` imports this module and hands `extractReceipt`
// to `useExpenseEntryForm` (#106) and `isReceiptOcrConfigured` to
// `AddNewDrawer`. No component below a page imports it, so those components
// render in the `ui` project (#114).

import { auth } from './firebase';
import { ReceiptOcrError, makeExtractReceipt, normaliseBaseUrl } from './receiptOcrClient';

const BASE = normaliseBaseUrl(import.meta.env.VITE_RECEIPT_OCR_URL);

export const isReceiptOcrConfigured = Boolean(BASE);

export { ReceiptOcrError };

export const extractReceipt = makeExtractReceipt({
  baseUrl: BASE,
  // Read per call, not captured: a scan started before the auth state settles
  // would otherwise hold a null for the life of the page.
  getUser: () => auth?.currentUser,
});
